// Ported from Frontend/discovery/vsee-clinic/src/lib/loadVSeeScript.ts.
let scriptPromise: Promise<void> | null = null;

/** Loads the VSee Browser Call SDK (external_api.min.js) exactly once and
 * resolves once `window.JitsiMeetExternalAPI` is available. */
export function loadVSeeScript(scriptUrl: string): Promise<void> {
  if (window.JitsiMeetExternalAPI) return Promise.resolve();

  if (!scriptPromise) {
    scriptPromise = new Promise<void>((resolve, reject) => {
      const existing = document.querySelector<HTMLScriptElement>(
        `script[src="${scriptUrl}"]`,
      );
      if (existing) {
        existing.addEventListener("load", () => resolve());
        existing.addEventListener("error", () =>
          reject(new Error(`Failed to load ${scriptUrl}`)),
        );
        return;
      }

      const script = document.createElement("script");
      script.src = scriptUrl;
      script.async = true;
      script.addEventListener("load", () => resolve());
      script.addEventListener("error", () =>
        reject(new Error(`Failed to load ${scriptUrl}`)),
      );
      document.head.appendChild(script);
    });
  }

  return scriptPromise;
}
